import { useEffect, useState } from 'react';
import { EarconName, useEarcon } from '../../../../hooks/useEarcon';
import useOnFocusOut from '../../../../hooks/useOnFocusOut';
import { createUseTextLocalizer } from '../../../../locale/createUseTextLocalizer';
import CompositeInputBundle from '../../NovaComponents-CompositeInput-gui-icu.properties';
const useTextLocalizer = createUseTextLocalizer(CompositeInputBundle);
/**
 * This hook can be used for validating required fields in Composite Input control.
 */
export const useRequiredValidationAdapter = ({
  value,
  inputProps
}) => {
  const localize = useTextLocalizer();
  const [showRequiredError, setShowRequiredError] = useState(false);
  const shouldShowError = showRequiredError && !!inputProps?.required;
  const [errorTimerFinished, setErrorTimerFinished] = useState(false);
  const delayedShowRequiredError = shouldShowError && errorTimerFinished;
  const earcon = useEarcon({
    source: EarconName.InputFull
  });
  useEffect(() => {
    if (!shouldShowError) {
      setErrorTimerFinished(false);
      return;
    }
    const timer = setTimeout(() => {
      setErrorTimerFinished(true);
    }, 200);
    return () => clearTimeout(timer);
  }, [shouldShowError]);
  useEffect(() => {
    setShowRequiredError(false);
  }, [value]);
  const {
    onFocus: internalOnFocus,
    onBlur: internalOnBlur
  } = useOnFocusOut(() => {
    if (!value.trim()) setShowRequiredError(true);
  });
  const onFocus = () => {
    inputProps?.onFocus?.();
    internalOnFocus?.();
  };
  const onBlur = () => {
    inputProps?.onBlur?.();
    internalOnBlur?.();
  };
  const onCancel = () => {
    inputProps?.onCancel?.();
    setShowRequiredError(false);
  };
  const onCommit = e => {
    inputProps?.onCommit?.(e);
    if (!value.trim()) setShowRequiredError(true);
    if (inputProps?.required === true && !value.trim() && e?.reason === 'enter') earcon.play();
  };
  const errorState = delayedShowRequiredError ? {
    status: 'alert',
    message: inputProps?.requiredErrorMessage ?? localize('required.error.msg')
  } : {
    status: inputProps?.status,
    message: inputProps?.message
  };
  return {
    onFocus,
    onBlur,
    onCancel,
    onCommit,
    errorState
  };
};
//# sourceMappingURL=useRequiredValidationAdapter.js.map